import { applyMiddleware, combineReducers, createStore } from "redux";
import ReduxThunk from "redux-thunk";

import authReducer from "./reducers/authReducer";
import chartsReducer from "./reducers/chartsReducer";
import condominiumReducer from "./reducers/condominiumReducer";
import employeesReducer from "./reducers/employeesReducer";
import medicalCertificatesReducer from "./reducers/medicalCertificatesReducer";
import punchCardReducer from "./reducers/punchCardReducer";

export const rootReducer = combineReducers({
  authReducer,
  condominiumReducer,
  employeesReducer,
  punchCardReducer,
  chartsReducer,
  medicalCertificatesReducer,
});

export type AppState = ReturnType<typeof rootReducer>;

const store = createStore(rootReducer, {}, applyMiddleware(ReduxThunk));

export default store;
